@if (_selectedNor) {
  <div class="row">
    <div class="col-md-6">
      <div>
        <div class="card shadow-sm">
          <div class="card-header with-border">NOR</div>
          <div class="card-body">
            <div>
              <form
                #norUpload="ngForm"
                class="form-horizontal"
                (ngSubmit)="saveNor()"
              >
                <div class="form-group row">
                  <app-material-date-range
                    id="selectedDate"
                    name="selectedDate"
                    [singleDateSelector]="true"
                    [disabled]="edit"
                    [(dateRange)]="_selectedDate"
                    [timePicker]="true"
                    required
                    [placeholder]="'Date & time'"
                    [localeDateFormat]="'YYYY-MM-DD HH:mm'"
                  >
                  </app-material-date-range>
                </div>
                <div class="form-group row">
                  <app-material-organisation-selector
                    class="pg-component"
                    [(ngModel)]="port!"
                    [organisationLanguage]="'en'"
                    name="port2"
                    [organisations]="portOrganisations"
                    [disabled]="edit"
                    [placeholder]="'port'"
                    [required]="true"
                  >
                  </app-material-organisation-selector>
                </div>
                <div class="form-group row">
                    <app-material-auto-complete
                      id="loadingDischarging"
                      [placeholder]="'NOR type'"
                      name="selectedDocumentType"
                      [disabled]="edit"
                      [(ngModel)]="_selectedNor.norType"
                      [items]="selectedNorTypes"
                      [formatter]="norTypeFormatter"
                      [required]="true">
                    </app-material-auto-complete>
                </div>
                <div class="form-group row">
                  <app-material-chunk-file-uploader
                    [accept]="'.pdf'"
                    name="document"
                    [(ngModel)]="doc"
                    (ngModelChange)="uploadDocument($event)"
                    [required]="true"
                  >
                  </app-material-chunk-file-uploader>
                </div>
                <div class="form-group col-md-12">
                  <label for="submit" class="col-form-label col-md-4"></label>
                  <div class="col-md-12" style="padding: 0">
                    <div class="btn-group pull-right">
                      <app-material-pg-button
                        id="cancel"
                        class="me-1"
                        (clicked)="backToVoyage()"
                        label="Back to voyage"
                      >
                      </app-material-pg-button>
                      @if ( edit && hasRole("vessels-voyages-editor")) {
                        <app-material-pg-button
                          class="pull-right me-1"
                          id="delete"
                          (clicked)="deleteNor()"
                          label="Delete">
                        </app-material-pg-button>
                      }
                      <app-material-pg-button
                        class="me-1"
                        id="submit"
                        (clicked)="saveNor()"
                        label="Save"
                        [disabled]="!norUpload.form.valid"
                      >
                      </app-material-pg-button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <app-material-pdf-viewer [fileId]="_selectedNor.fileId"></app-material-pdf-viewer>
    </div>
  </div>
}
